<template>
    <div class="btn-group table-status" data-toggle="buttons">
        <label v-for="(option, idx) in options"
            v-on:click="onUpdate(option)"
            :for="getInputKey(idx)"
            :key="option.id"
            :class="['btn', 'btn-radio', option.flavor, option.id == value ? 'active' : '']">
            <input v-on:input="onInput"
                type="radio" autocomplete="off"
                :id="getInputKey(idx)"
                :checked="option.id == value"
                :name="getInputKey()"
                :value="option.id"
                class="mr-1"> {{ option.name }}
        </label>
    </div>
</template>
<script>
export default {
    data() {
        return {
            randomKey: Math.floor(Math.random() * 1000000),
        }
    },

    props: ['value', 'disabled', 'values'],

    computed: {
        options() {
            return _.map(this.values, (value) => {
                if (_.isObject(value)) return value;

                return {
                    id: value,
                    name: value,
                    flavor: 'btn-primary',
                }
            });
        },
    },

    methods: {
        onInput(e) {
            const value = e.target.value;
            this.$emit('input', value);
        },

        onUpdate(option) {
            this.$emit('input', option.id);
        },

        getInputKey(id = '') {
            return `radio-${this.randomKey}-${id}`;
        },

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/CustomFlavorRadioComponent.vue